export const PeopleIcon = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_2617_18139)">
      <path d="M10.667 7.33331C11.7737 7.33331 12.6603 6.43998 12.6603 5.33331C12.6603 4.22665 11.7737 3.33331 10.667 3.33331C9.56033 3.33331 8.66699 4.22665 8.66699 5.33331C8.66699 6.43998 9.56033 7.33331 10.667 7.33331ZM5.33366 7.33331C6.44033 7.33331 7.32699 6.43998 7.32699 5.33331C7.32699 4.22665 6.44033 3.33331 5.33366 3.33331C4.22699 3.33331 3.33366 4.22665 3.33366 5.33331C3.33366 6.43998 4.22699 7.33331 5.33366 7.33331ZM5.33366 8.66665C3.78033 8.66665 0.666992 9.44665 0.666992 11V12.6666H10.0003V11C10.0003 9.44665 6.88699 8.66665 5.33366 8.66665ZM10.667 8.66665C10.4737 8.66665 10.2537 8.67998 10.0203 8.69998C10.7937 9.25998 11.3337 10.0133 11.3337 11V12.6666H15.3337V11C15.3337 9.44665 12.2203 8.66665 10.667 8.66665Z" />
    </g>
    <defs>
      <clipPath id="clip0_2617_18139">
        <rect width="16" height="16" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
